import { config } from "@/config";
import { chatApiAxios } from "@/plugins";
import { checkAccessTokenAsync } from "@/services";
import { DeleteAttachmentArgs } from "@/store/chats/types";
import { HttpRequestMethodEnum } from "@/types/api";
import { getCommonJsonHeaders } from "@/utils/api";

export const deleteAttachmentBeAsync = async (data: DeleteAttachmentArgs) => {
  const accessToken = await checkAccessTokenAsync();

  const res = await chatApiAxios(
    config.api.chatApi.endpoints.message.deleteAttachment,
    {
      method: HttpRequestMethodEnum.POST,
      headers: getCommonJsonHeaders(accessToken),
      data,
    },
  );

  return res.data;
};
